/** True when HTML content has no visible text — Quill's "empty" state is
 * "<p><br></p>", not an empty string, so a plain truthiness/trim check on
 * the raw HTML doesn't work for required-field or blank-answer checks. */
export function isHtmlEmpty(html: string | null | undefined): boolean {
  if (!html) return true;
  return !html.replace(/<[^>]*>/g, "").trim();
}
